import { Page } from "../Page/Page";
import { Grid } from "@mui/material";
import {
  WelcomeCoach,
  HowCanAiHelpCoach,
  Plans,
  AlreadyInTheGame,
  Footer,
  ImageAi,
} from "./components";
// import { WhatOurUserSay } from "./components/WhatOurUserSay";
import { styles } from "../../theme";


export const HomeCoach = () => {
  return (
    <Page menu>
      <Grid container spacing={2} style={{ ...styles.gridContainer }}>
        <WelcomeCoach></WelcomeCoach>
        <ImageAi></ImageAi>
        <HowCanAiHelpCoach id="functionalities"></HowCanAiHelpCoach>
        {/* <WhatOurU serSay></WhatOurUserSay> */}
        <Plans id="prices"></Plans>
        <AlreadyInTheGame></AlreadyInTheGame>
        <Footer id="about-us"></Footer>
      </Grid>
    </Page>
  );
};

